import React, { Fragment } from "react"
import { useTranslation } from "react-i18next"

import { moment } from "utils"
import classes from "./OfflineOrderDetailsHeader.module.scss"

const OfflineOrderDetailsHeader = props => {
  const { offlineOrder } = props

  const [t] = useTranslation()

  const showPaidDate =
    offlineOrder.orderStatus === "paid"

  const showCancelReasons =
    offlineOrder.orderStatus === "canceled"

  const showOrderNote =
    !!offlineOrder.note

  return (
    <Fragment>

      {
        !!offlineOrder.referenceCode &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("کد_پیگیری")}
          </span>
          <div className={classes["date"]}>
            {offlineOrder.referenceCode}
          </div>
        </div>
      }

      {
        offlineOrder.deliveryType === "dineIn" &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("شماره_میز")}
          </span>
          <div className={classes["date"]}>
            {offlineOrder.tableNumber}
          </div>
        </div>
      }

      {
        offlineOrder.deliveryType === "cinema" &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("سالن_سینما")}
          </span>
          <div className={classes["date"]}>
            {offlineOrder.cinemaSolonNumber}
          </div>
        </div>
      }

      {
        offlineOrder.deliveryType === "selfPickup" &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("بیرون_بر")}
          </span>
        </div>
      }

      <div className={classes["title-container"]}>
        <span className={classes["title"]}>
          {t("تاریخ_ایجاد_سفارش")}
        </span>
        <div className={classes["date"]}>
          {moment(offlineOrder.date).format("jYYYY/jMM/jDD - HH:mm")}
        </div>
      </div>

      {
        showPaidDate &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("تاریخ_پرداخت")}
          </span>
          <div className={classes["date"]}>
            {moment(offlineOrder.date).format("jYYYY/jMM/jDD - HH:mm")}
          </div>
        </div>
      }

      {
        !!offlineOrder.canceledAt &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("تاریخ_لغو_سفارش")}
          </span>
          <div className={classes["date"]}>
            {moment(offlineOrder.canceledAt).format("jYYYY/jMM/jDD - HH:mm")}
          </div>
        </div>
      }

      {
        !!offlineOrder.deliveredAt &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("تاریخ_تکمیل_سفارش")}
          </span>
          <div className={classes["date"]}>
            {moment(offlineOrder.deliveredAt).format("jYYYY/jMM/jDD - HH:mm")}
          </div>
        </div>
      }

      {
        !!offlineOrder.dispatchedAt &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("تاریخ_خروج_از_انبار")}
          </span>
          <div className={classes["date"]}>
            {moment(offlineOrder.dispatchedAt).format("jYYYY/jMM/jDD - HH:mm")}
          </div>
        </div>
      }

      {
        showCancelReasons &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("دلیل_لغو_سفارش")}
          </span>
          <div className={classes["cancel-note"]}>
            {offlineOrder.cancelReasons}
          </div>
        </div>
      }

      {
        showOrderNote &&
        <div className={classes["title-container"]}>
          <span className={classes["title"]}>
            {t("توضیحات_سفارش")}
          </span>
          <div className={classes["date"]}>
            {offlineOrder.note}
          </div>
        </div>
      }
    </Fragment>
  )
}

export default OfflineOrderDetailsHeader